import { ComponentProps } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Button } from 'components/Button/Button';
import { colors } from 'theme/theme';

const aSlideRTLBackground = keyframes`
  from {
    clip-path: inset(0 0 0 100%);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
`;

type EstimatedRangeButtonProps = ComponentProps<typeof Button>;

export const EstimatedRangeButton = styled(Button)<EstimatedRangeButtonProps>`
  background-color: ${colors.selectionGrey} !important;
  border: none;
  color: ${colors.mediumContentGrey} !important;
  position: relative;
  overflow: hidden;
  transition: clip-path;

  &::after {
    align-items: center;
    background-color: ${colors.brandBlue};
    clip-path: inset(0 0 0 100%);
    color: white;
    display: flex;
    justify-content: center;
    content: 'Estimated Range';
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;

    ${(props) =>
      props.variant !== 'inactive'
        ? css`
            animation: ${aSlideRTLBackground} 1s forwards;
          `
        : undefined}
  }

  &:hover {
    color: ${colors.brandBlue} !important;
  }

  &:disabled {
    opacity: 1;

    &:hover {
      color: initial !important;
    }
  }
`;
